<template>
  <form-wizard ref="formWizard" @on-change="onStepChange">
    <template slot="title"><span></span></template>
    <template slot="step"><span></span></template>

    <two-column-layout :class="$style.stepperHeader">
      <stepper-group-fragment>
        <stepper-step-fragment
          first-item
          :index="1"
          :label="$t(i18n.license_plate_step.title)"
          :active="0 === activeStep"
          :valid="0 < activeStep"
        ></stepper-step-fragment>
        <stepper-step-fragment
          :index="2"
          :label="$t(i18n.additional_coverages_step.title)"
          :active="1 === activeStep"
          :valid="1 < activeStep"
        ></stepper-step-fragment>
        <stepper-step-fragment
          :index="3"
          :label="$t(i18n.starting_date_step.title)"
          :active="2 === activeStep"
          :valid="2 < activeStep"
        ></stepper-step-fragment>
      </stepper-group-fragment>
    </two-column-layout>

    <tab-content title="Kenteken">
      <license-plate-step v-if="lazyLoadSteps[0]" ref="step_0" @nextStep="nextStep"/>
    </tab-content>
    <tab-content title="Aanvullende vragen">
      <additional-coverages-step v-if="lazyLoadSteps[1]" ref="step_1" @previousStep="previousStep" @nextStep="nextStep"/>
    </tab-content>
    <tab-content title="Ingangsdatum">
      <starting-date-step v-if="lazyLoadSteps[2]" ref="step_2" @previousStep="previousStep" @submit="onSubmit" />
    </tab-content>

    <template slot="footer"><span></span></template>
  </form-wizard>
</template>

<script>
  import {Api, Utils} from "@bvm/core";
  import {FormWizard, TabContent} from "vue-form-wizard";
  import {StepperGroupFragment, StepperStepFragment, TwoColumnLayout} from "@bvm/forms";
  import {finalizeForm} from "./api/single-vehicle-api";
  import {createNamespacedHelpers} from "vuex";

  const { mapGetters, mapMutations } = createNamespacedHelpers(
        "registerSingleVehicle"
);
const i18nBuilder = new Utils.I18n.I18nBuilder("register_single_vehicle_form")
  .add("license_plate_step", b => b.add("title"))
  .add("additional_coverages_step", b => b.add("title"))
  .add("starting_date_step", b => b.add("title"))
  .add("submission_failure");

const i18nValidationBuilder = new Utils.I18n.I18nBuilder("validations_field")
  .add("option_required")
  .add("field_required");

export const messageKeys = [...i18nBuilder.getKeys(), ...i18nValidationBuilder.getKeys()];

const numberOfSteps = 3;

export default {
  name: "register-single-vehicle-form",
  components: {
    FormWizard,
    TabContent,
    TwoColumnLayout,
    StepperGroupFragment,
    StepperStepFragment,
    "license-plate-step": () => import("./steps/license-plate-step"),
    "additional-coverages-step": () => import("./steps/additional-coverages-step"),
    "starting-date-step": () => import("./steps/starting-date-step")
  },
  props: {},
  data() {
    return {
      i18n: i18nBuilder.getData(),
      lazyLoadSteps: Object.assign({}, [true, ...Array(numberOfSteps - 1)]),
      activeStep: 0,
      finalizing: false
    };
  },
  computed: {
    ...mapGetters(["getPostData"])
  },
  provide() {
    return {
      activeStep: () => this.activeStep
    };
  },
  methods: {
    ...mapMutations(["resetState"]),
    onStepChange(prevIndex, nextIndex) {
      // Load step component if not loaded yet.
      // Is lazy loaded based on v-if
      this.activeStep = nextIndex;
      this.lazyLoadSteps[nextIndex] = true;

      // Invoke loadStep function if available
      // Note: step ref is not yet available on initial lazy load
      let ref = this.$refs[`step_${this.activeStep}`];
      if (ref && ref.loadStep) {
        ref.loadStep();
      }
      // scroll to top of form
      document.getElementsByClassName("vue-form-wizard")[0].scrollIntoView(true);
      // make sure the stepper is also included in the view
      window.scrollBy(0, -100);
    },
    nextStep() {
      this.$refs.formWizard.nextTab();
    },
    previousStep() {
      this.$refs.formWizard.prevTab();
    },
    onSubmit() {
      if (this.finalizing) {
        return;
      }
      this.finalizing = true;

      finalizeForm(this.getPostData)
        .then(() => {
          this.resetState();
          Api.SpecialPage.goToSpecialPage("REGISTER_SINGLE_VEHICLE_REGISTRATION_SUCCESS");
        }).catch(() => {
          this.finalizing = false;
          Bovemij.notifyFailure('',this.$t(this.i18n.submission_failure))
        });
    }
  }
};
</script>

<style module lang="scss">
.stepperHeader {
  margin-bottom: 20px;
}

/* Added overrides for senseless hiding of input date picker in `libs/style/src/assets/scss/angular/partials/_date-picker.scss` */
input::-webkit-calendar-picker-indicator {
  display: block !important;
}

input[type="date"]::-webkit-input-placeholder {
  visibility: visible !important;
}
</style>
